import * as React from "react";
import { Link } from "react-router";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import { Category } from "../../models/category";
import List, { ListItem, ListItemText, ListItemIcon } from "material-ui/List";
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card';
import Busy from "../../components/widgets/busy";
import InboxIcon from 'material-ui-icons/Inbox';
import Divider from 'material-ui/Divider';
import { Row, Col, Grid } from "react-flexbox-grid";
import { ScreenMode, BusyEvent } from "../../models/enums";
import Paper from "material-ui/Paper";
import SvgIcon from 'material-ui/SvgIcon';
import * as s from "./categories.css";

@inject("store") @observer
export default class Categories extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }
  renderCategories(): JSX.Element { 
    const paper: any = { backgroundColor: "#F6F8F8" };
    let imgUrl: string;
    let cats: JSX.Element[] = [];
    let iconUrl: string;
    const openLabel: string = this.props.store.localization.fields.open;
    this.props.store.opportunityStore.categories.map((cat: Category, i: number): void => {
      iconUrl = "../image/" + cat.iconId;
      cats.push(<Col sm={3} md={2} key={cat.idHash} className={s.iconCol}>
        <div  onClick={() => hashHistory.push(`/categories/${cat.idHash}/opportunities`)}>
        <img src={iconUrl} className={s.desktopIcon}/>
        <div className={s.centerList}>
            <p className={s.catName}>{`${cat.name} (${cat.opportunityCt})`}</p>
        </div>
        </div>
      </Col>);
    });
    return (<Paper elevation={4} className={s.paper} style={paper} ><div className={s.container}>
      <Row><h4 className={s.featureTitle}>{this.props.store.localization.fields.categories}</h4></Row>
      {this.props.store.viewState.isBusy(BusyEvent.LoadCategories) && <Row><Busy show={true} size="md" /></Row>}
      <Row><p className={s.subTitle}>{this.props.store.localization.fields.categorySubheading}</p></Row>
      <Grid fluid><Row>{cats}</Row></Grid>
    </div></Paper>);
  }

  renderCategoriesMobile(): JSX.Element {
    const MuiListItem: any = {
        paddingTop: "0",
        paddingBottom: "0",
      }  
    let cats: JSX.Element[] = [];
    let iconUrl: string;
    const openLabel: string = this.props.store.localization.fields.open;
    this.props.store.opportunityStore.categories.map((cat: Category, i: number): void => {
      iconUrl = "../image/" + cat.iconId;
      cats.push(<Col xs={12} className={s.customCol} key={cat.idHash} >
        <List>
          <ListItem style={MuiListItem} key={i} onClick={() => hashHistory.push(`/categories/${cat.idHash}/opportunities`)}>
            <img src={iconUrl} height="40px" width="40px" /><ListItemText primary={`${cat.name} (${cat.opportunityCt})`}/></ListItem></List></Col>);
    });
    return (<div>
      <Grid><Row><h4 className={s.featureTitleMobile}>{this.props.store.localization.fields.categories}</h4></Row>
        {this.props.store.viewState.isBusy(BusyEvent.LoadCategories) && <Row><Busy show={true} size="sm" /></Row>}
        <Row><p className={s.subTitleMobile}>{this.props.store.localization.fields.categorySubheading}</p></Row>
        <Row className={s.customRow}>{cats}</Row></Grid>
      </div>);
  }
  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<div> 
        {mode === ScreenMode.Mobile && this.renderCategoriesMobile()}
        {mode !== ScreenMode.Mobile && this.renderCategories()}       
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/categories/index.tsx